import { useQuery } from "@tanstack/react-query";
import moment from "moment/moment";
import React, { useState } from "react";
import { getEvents } from "../../services/services";
import { constant } from "../../utils/constants";
import { getTableIndex } from "../../utils/function";
import Pagination from "../../utils/Pagination";
import AddRequest from "./AddRequest";
import { IoMdAdd } from "react-icons/io";
import { CiFilter } from "react-icons/ci";
import FilterModal from "../../common/FilterModal";

const Request = () => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState();
  const [page, setPage] = useState(constant.PAGE_NO_ONE);
  const [isToggled, setIsToggled] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filterData, setFilterData] = useState({});

  const handleShow = () => setShow(true);
  const handleToggle = () => setIsToggled(!isToggled);
  const handleFilterShow = () => setFilterShow(true);

  const { data, refetch } = useQuery({
    queryKey: ["shift-list", page, isToggled, filterData],
    queryFn: async () => {
      let params = {
        page: page,
        limit: constant.PAGE_LIMIT,
        requestedEvents: true,
        sortedBy: constant.SORTED_BY.START_TIME,
        sortBy: constant.SORT_BY.ASC
      };
      if (search) params.search = search;
      if (isToggled) {
        params.sortBy = constant.SORT_BY.DESC;
        params.previousEvents = true;
      } else {
        params.futureEvents = true;
      }
      if (
        Object.keys(filterData).length &&
        Object.keys(filterData).filter((item) => filterData[item]).length
      ) {
        params.range = `${filterData.start}TO${filterData.end}`;
      }
      const resp = await getEvents(params);
      return resp?.data?.data || {};
    },
  });

  return (
    <section className="main-content">
      <div className="commonSearchBar mt-3">
        <h4 className="heading20">Appointment Request</h4>
        <div className="endContent">
          <div className="toggle-container">
            <div
              className={`toggle-switch ${isToggled ? "toggled" : ""}`}
              onClick={handleToggle}
            >
              <div className={`slider ${isToggled ? "toggled" : ""}`}></div>
            </div>
            <label className="label-text">Past Assignment</label>
          </div>
          <div className="position-relative">
            {Object.keys(filterData).length &&
            Object.keys(filterData).filter((item) => filterData[item])
              .length ? (
              <div className="redDot" />
            ) : (
              ""
            )}
            <button
              className="greenBtn calendar-btn"
              type="button"
              title="Filter By"
              onClick={handleFilterShow}
            >
              <CiFilter size={35} />
            </button>
          </div>
          <button
            className="greenBtn calendar-btn"
            type="button"
            title="Add Event"
            onClick={handleShow}
          >
            <IoMdAdd size={35} />
          </button>
        </div>
      </div>
      <div className="container-fluid p-0">
        <div className="row mt-4">
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="commonTable">
                <thead className="tableHead">
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Note</th>
                    <th>Address</th>
                    <th>Phone Number</th>
                    <th>Email</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {data && data?.events && data?.events?.length > 0 ? (
                    data?.events?.map((event, index) => {
                      const clientDetails = event?.clientDetails || null;
                      return (
                        <tr key={`event_${index}`}>
                          <td>{moment(event?.startTime).format("ll")}</td>
                          <td>
                            {moment(event?.startTime).format("LT")} -{" "}
                            {moment(event?.endTime).format("LT")}
                          </td>
                          <td>{event?.note?.trim()?event?.note:"N/A"}</td>
                          <td>{`${clientDetails?.userAddress?.address} ${clientDetails?.userAddress?.city} ${clientDetails?.userAddress?.state} ${clientDetails?.userAddress?.country} (${clientDetails?.userAddress?.zipCode})`}</td>
                          <td>{clientDetails?.phoneNumber}</td>
                          <td>{clientDetails?.email}</td>
                          <td>{moment(event?.createdAt).format("lll")}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="text-center" colSpan={10}>
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                page={page}
                setPage={setPage}
                totalPages={data?.total_pages}
              />
            </div>
          </div>
        </div>
      </div>
      {show && <AddRequest show={show} setShow={setShow} refetch={refetch} />}
      {filterShow && (
        <FilterModal
          show={filterShow}
          setShow={setFilterShow}
          refetch={refetch}
          data={filterData}
          setData={setFilterData}
        />
      )}
    </section>
  );
};

export default Request;